<div class="alert alert-info message-container" *ngIf="isNewAppVersionAvailable">
    <div class="d-flex align-items-center">
        <div>
            <span class="pr-2">Nueva Version</span>
            <small class="pr-2">
                Una nueva versión de la aplicación está disponible. Actualice la ventana de su navegador o haga clic en
                el botón Actualizar.
            </small>
        </div>
        <div>
            <button (click)="refreshApp()" class="btn btn-primary btn-sm rounded-pill">
                <span class="text-nowrap">Refrescar</span>
            </button>
        </div>
    </div>
</div>

<nav class="navbar sticky-top cc-nav-custom">
    <div class="row w-100 my-1">
        <div class="col-12 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center justify-content-start">
                <img src="assets/img/logo-otic-sofofa-main.svg" alt="logo-sofofa" width="83px" height="33px">
                <!-- <p class="cc-titulo-header m-0 ms-4">Selección Personas</p> -->
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <div class="notification position-relative me-3" (click)="toggleModal()">
                    <img src="assets/img/icon-notification.svg" alt="notificaciones" width="24" height="24"
                        class="notification-icon">
                    <span *ngIf="unreadCount > 0" class="badge rounded-pill bg-danger notification-badge">
                        {{ unreadCount > 9 ? '9+' : unreadCount }}
                    </span>
                </div>

                <div class="d-flex align-items-center">
                    <span class="badge ms-3 me-1">
                        <app-avatar [name]="user?.nombres" [imgUrl]="user?.attributes?.profile_pic?.[0] ?? null"
                            [size]="36" [useRandomColor]="false">
                        </app-avatar>
                    </span>
                    <div class="d-flex flex-column">
                        <p class="mb-0 cc-nombre-usuario">
                            {{user?.nombres}}
                            <!-- {{ user?.attributes?.name[0] || user?.firstName + ' ' + user?.lastName }} -->
                        </p>
                        <ng-container *ngIf="user?.organizations">
                            <p class="mb-0 cc-cargo-usuario">{{ user?.organizations[0]?.title | titlecase }}</p>
                        </ng-container>
                        <ng-container *ngIf="!user?.organizations">
                            <p class="mb-0 cc-cargo-usuario"> {{user?.perfil?.nombre}} </p>
                        </ng-container>
                    </div>
                    <button class="btn btn-outline-danger btn-sm ms-2" (click)="logout()">
                        Cerrar sesión
                    </button>
                </div>
            </div>
        </div>
    </div>
</nav>